// // // // // import React, { useEffect, useState } from "react";
// // // // // import { useParams } from "react-router-dom";
// // // // // import api from "../api";

// // // // // export default function OrderFromCustomer() {
// // // // //   const { tableId } = useParams();
// // // // //   const [table, setTable] = useState(null);
// // // // //   const [menu, setMenu] = useState([]);
// // // // //   const [order, setOrder] = useState([]);
// // // // //   const [loading, setLoading] = useState(true);

// // // // //   function addItem(item) {
// // // // //   const existing = order.find((o) => o.item._id === item._id);
// // // // //   if (existing) {
// // // // //     setOrder(order.map((o) =>
// // // // //       o.item._id === item._id ? { ...o, qty: o.qty + 1 } : o
// // // // //     ));
// // // // //   } else {
// // // // //     setOrder([...order, { item, qty: 1 }]);
// // // // //   }
// // // // // }

// // // // // function changeQty(itemId, qty) {
// // // // //   setOrder(order.map((o) =>
// // // // //     o.item._id === itemId ? { ...o, qty } : o
// // // // //   ));
// // // // // }


// // // // //   useEffect(() => {
// // // // //     loadData();
// // // // //   }, [tableId]);

// // // // //   async function loadData() {
// // // // //   try {
// // // // //     const [tRes, mRes] = await Promise.all([
// // // // //       api.get(`/tables/${tableId}`),
// // // // //       api.get(`/menu`),
// // // // //     ]);

// // // // //     setTable(tRes.data);
// // // // //     setMenu(mRes.data);
// // // // //   } catch (err) {
// // // // //     console.error("Load error:", err.response?.data || err.message);
// // // // //     alert("Failed to load menu or table info.");
// // // // //   } finally {
// // // // //     setLoading(false);
// // // // //   }
// // // // // }

// // // // // async function submitOrder() {
// // // // //   if (order.length === 0) return alert("Please add at least one item.");
// // // // //   try {
// // // // //     await api.post(`/tables/${tableId}/orders`, {
// // // // //       items: order.map((o) => ({
// // // // //         item: o.item._id,
// // // // //         qty: o.qty,
// // // // //       })),
// // // // //     });
// // // // //     alert("✅ Order placed successfully!");
// // // // //     setOrder([]);
// // // // //   } catch (err) {
// // // // //     console.error("Order submit error:", err.response?.data || err.message);
// // // // //     alert("❌ Failed to place order");
// // // // //   }
// // // // // }



// // // // //   if (loading) return <div className="p-6 text-center">Loading...</div>;

// // // // //   return (
// // // // //     <div className="p-6 bg-gray-50 min-h-screen">
// // // // //       <h2 className="text-2xl font-bold text-center mb-4">
// // // // //         🍽️ Welcome to {table?.name || "your table"}
// // // // //       </h2>

// // // // //       {/* Menu List */}
// // // // //       <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
// // // // //         {menu.map((m) => (
// // // // //           <div
// // // // //             key={m._id}
// // // // //             className="bg-white shadow rounded-lg p-3 flex flex-col items-center justify-between"
// // // // //           >
// // // // //             <div className="font-semibold">{m.name}</div>
// // // // //             <div className="text-gray-600">₹{m.price}</div>
// // // // //             <button
// // // // //               className="bg-green-600 text-white px-3 py-1 rounded mt-2 hover:bg-green-700"
// // // // //               onClick={() => addItem(m)}
// // // // //             >
// // // // //               Add
// // // // //             </button>
// // // // //           </div>
// // // // //         ))}
// // // // //       </div>

// // // // //       {/* Selected Order */}
// // // // //       {order.length > 0 && (
// // // // //         <div className="bg-white shadow rounded-lg p-4">
// // // // //           <h3 className="text-lg font-semibold mb-3">🧾 Your Order</h3>
// // // // //           {order.map((o) => (
// // // // //             <div key={o.item._id} className="flex justify-between items-center mb-2">
// // // // //               <span>{o.item.name}</span>
// // // // //               <input
// // // // //                 type="number"
// // // // //                 min="1"
// // // // //                 value={o.qty}
// // // // //                 onChange={(e) => changeQty(o.item._id, Number(e.target.value))}
// // // // //                 className="border rounded px-2 w-16 text-center"
// // // // //               />
// // // // //             </div>
// // // // //           ))}
// // // // //           <button
// // // // //             className="bg-blue-600 text-white w-full py-2 rounded mt-3 hover:bg-blue-700"
// // // // //             onClick={submitOrder}
// // // // //           >
// // // // //             ✅ Place Order
// // // // //           </button>
// // // // //         </div>
// // // // //       )}
// // // // //     </div>
// // // // //   );
// // // // // }


// // // // import React, { useEffect, useState } from "react";
// // // // import { useParams } from "react-router-dom";
// // // // import api from "../api";

// // // // export default function OrderFromCustomer() {
// // // //   const { tableId } = useParams();
// // // //   const [table, setTable] = useState(null);
// // // //   const [menu, setMenu] = useState([]);
// // // //   const [order, setOrder] = useState([]);
// // // //   const [loading, setLoading] = useState(true);
// // // //   const [search, setSearch] = useState("");

// // // //   // Add or update item in order
// // // //   function addItem(item, qty = 1) {
// // // //     const existing = order.find((o) => o.item._id === item._id);
// // // //     if (existing) {
// // // //       setOrder(order.map((o) =>
// // // //         o.item._id === item._id ? { ...o, qty: o.qty + qty } : o
// // // //       ));
// // // //     } else {
// // // //       setOrder([...order, { item, qty }]);
// // // //     }
// // // //   }

// // // //   // Change quantity
// // // //   function changeQty(itemId, qty) {
// // // //     if (qty <= 0) {
// // // //       setOrder(order.filter(o => o.item._id !== itemId));
// // // //     } else {
// // // //       setOrder(order.map((o) =>
// // // //         o.item._id === itemId ? { ...o, qty } : o
// // // //       ));
// // // //     }
// // // //   }

// // // //   useEffect(() => {
// // // //     async function loadData() {
// // // //       try {
// // // //         const [tRes, mRes] = await Promise.all([
// // // //           api.get(`/tables/${tableId}`),
// // // //           api.get(`/menu`),
// // // //         ]);
// // // //         setTable(tRes.data);
// // // //         setMenu(mRes.data);
// // // //       } catch (err) {
// // // //         console.error("Load error:", err.response?.data || err.message);
// // // //         alert("Failed to load menu or table info.");
// // // //       } finally {
// // // //         setLoading(false);
// // // //       }
// // // //     }
// // // //     loadData();
// // // //   }, [tableId]);

// // // //   async function submitOrder() {
// // // //     if (order.length === 0) return alert("Please add at least one item.");
// // // //     try {
// // // //       await api.post(`/tables/${tableId}/orders`, {
// // // //         items: order.map((o) => ({ item: o.item._id, qty: o.qty })),
// // // //       });
// // // //       alert("✅ Order placed successfully!");
// // // //       setOrder([]);
// // // //     } catch (err) {
// // // //       console.error("Order submit error:", err.response?.data || err.message);
// // // //       alert("❌ Failed to place order");
// // // //     }
// // // //   }

// // // //   if (loading) return <div className="p-6 text-center">Loading...</div>;

// // // //   // Filter menu based on search
// // // //   const filteredMenu = menu.filter((m) =>
// // // //     m.name.toLowerCase().includes(search.toLowerCase())
// // // //   );

// // // //   return (
// // // //     <div className="p-6 bg-gray-50 min-h-screen">
// // // //       <h2 className="text-2xl font-bold text-center mb-4">
// // // //         🍽️ {table?.name}
// // // //       </h2>

// // // //       {/* Search Bar */}
// // // //       <div className="mb-4 flex justify-center">
// // // //         <input
// // // //           type="text"
// // // //           placeholder="Search menu items..."
// // // //           value={search}
// // // //           onChange={(e) => setSearch(e.target.value)}
// // // //           className="border p-2 w-full max-w-md rounded"
// // // //         />
// // // //       </div>

// // // //       {/* Menu Grid */}
// // // //       <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
// // // //         {filteredMenu.length > 0 ? filteredMenu.map((m) => {
// // // //           const itemInOrder = order.find(o => o.item._id === m._id);
// // // //           const qty = itemInOrder ? itemInOrder.qty : 0;
// // // //           return (
// // // //             <div
// // // //               key={m._id}
// // // //               className="bg-white shadow rounded-lg p-3 flex flex-col items-center justify-between"
// // // //             >
// // // //               <div className="font-semibold">{m.name}</div>
// // // //               <div className="text-gray-600">₹{m.price}</div>
// // // //               <div className="flex items-center mt-2 gap-2">
// // // //                 <button
// // // //                   onClick={() => changeQty(m._id, qty - 1)}
// // // //                   className="bg-gray-200 hover:bg-gray-300 w-8 h-8 rounded flex items-center justify-center font-bold"
// // // //                 >
// // // //                   −
// // // //                 </button>
// // // //                 <input
// // // //                   type="number"
// // // //                   min="0"
// // // //                   value={qty}
// // // //                   onChange={(e) => changeQty(m._id, Number(e.target.value))}
// // // //                   className="w-12 text-center border rounded py-1"
// // // //                 />
// // // //                 <button
// // // //                   onClick={() => addItem(m, 1)}
// // // //                   className="bg-green-600 hover:bg-green-700 text-white w-8 h-8 rounded flex items-center justify-center font-bold"
// // // //                 >
// // // //                   +
// // // //                 </button>
// // // //               </div>
// // // //               <div className="text-sm mt-1">
// // // //                 Total: ₹{qty * m.price}
// // // //               </div>
// // // //             </div>
// // // //           );
// // // //         }) : (
// // // //           <div className="col-span-full text-center text-gray-500">No items found</div>
// // // //         )}
// // // //       </div>

// // // //       {/* Order Summary */}
// // // //       {order.length > 0 && (
// // // //         <div className="bg-white shadow rounded-lg p-4 sticky bottom-4">
// // // //           <h3 className="text-lg font-semibold mb-3">🧾 Your Order</h3>
// // // //           {order.map((o) => (
// // // //             <div key={o.item._id} className="flex justify-between items-center mb-2">
// // // //               <span>{o.item.name}</span>
// // // //               <span>₹{o.item.price * o.qty}</span>
// // // //               <input
// // // //                 type="number"
// // // //                 min="1"
// // // //                 value={o.qty}
// // // //                 onChange={(e) => changeQty(o.item._id, Number(e.target.value))}
// // // //                 className="border rounded px-2 w-16 text-center"
// // // //               />
// // // //             </div>
// // // //           ))}
// // // //           <div className="font-bold mt-2 flex justify-between">
// // // //             <span>Total:</span>
// // // //             <span>₹{order.reduce((sum, o) => sum + o.item.price * o.qty, 0)}</span>
// // // //           </div>
// // // //           <button
// // // //             className="bg-blue-600 text-white w-full py-2 rounded mt-3 hover:bg-blue-700"
// // // //             onClick={submitOrder}
// // // //           >
// // // //             ✅ Place Order
// // // //           </button>
// // // //         </div>
// // // //       )}
// // // //     </div>
// // // //   );
// // // // }


// // // import React, { useEffect, useState } from "react";
// // // import { useParams } from "react-router-dom";
// // // import api from "../api";
// // // import socket from "../socket";





// // // export default function OrderFromCustomer() {
// // //   const { tableId } = useParams();
// // //   const [table, setTable] = useState(null);
// // //   const [menu, setMenu] = useState([]);
// // //   const [order, setOrder] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [search, setSearch] = useState("");
// // //   const [chat, setChat] = useState([]);
// // //   const [aiInput, setAiInput] = useState("");
// // //   const [pendingItems, setPendingItems] = useState(null);


  
// // //   function addItem(item, qty = 1) {
// // //     const existing = order.find((o) => o.item._id === item._id);
// // //     if (existing) {
// // //       setOrder(order.map((o) =>
// // //         o.item._id === item._id ? { ...o, qty: o.qty + qty } : o
// // //       ));
// // //     } else {
// // //       setOrder([...order, { item, qty }]);
// // //     }
// // //   }

// // //   function changeQty(itemId, qty) {
// // //     if (qty <= 0) {
// // //       setOrder(order.filter(o => o.item._id !== itemId));
// // //     } else {
// // //       setOrder(order.map((o) =>
// // //         o.item._id === itemId ? { ...o, qty } : o
// // //       ));
// // //     }
// // //   }

// // //   async function sendToAI(confirm = false) {
// // //   if (!aiInput && !confirm) return;

// // //   const res = await api.post("/waiter", {
// // //     tableId,
// // //     message: confirm ? "yes" : aiInput,
// // //     confirm
// // //   });

// // //   if (res.data.reply) {
// // //     setChat(prev => [...prev, { from: "ai", text: res.data.reply }]);
// // //   }

// // //   if (res.data.items) {
// // //     setPendingItems(res.data.items);
// // //   }

// // //   if (res.data.success) {
// // //     alert("✅ Order placed via AI");
// // //     setPendingItems(null);
// // //     setChat([]);
// // //   }

// // //   setAiInput("");
// // // }

// // // function startVoice() {
// // //   const SpeechRecognition =
// // //     window.SpeechRecognition || window.webkitSpeechRecognition;

// // //   const recognition = new SpeechRecognition();
// // //   recognition.lang = "en-IN";

// // //   recognition.onresult = (e) => {
// // //     const text = e.results[0][0].transcript;
// // //     setAiInput(text);
// // //     sendToAI(false);
// // //   };

// // //   recognition.start();
// // // }



// // //   useEffect(() => {
// // //     async function loadData() {
// // //       try {
// // //         const [tRes, mRes] = await Promise.all([
// // //           api.get(`/tables/${tableId}`),
// // //           api.get(`/menu`),
// // //         ]);
// // //         setTable(tRes.data);
// // //         setMenu(mRes.data);
// // //       } catch (err) {
// // //         console.error("Load error:", err);
// // //         alert("Failed to load menu or table info.");
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     }
// // //     loadData();
// // //   }, [tableId]);

// // //   // 🔥 FIX: Emit event after placing order
// // //   async function submitOrder() {
// // //     if (order.length === 0) return alert("Please add at least one item.");

// // //     try {
// // //       await api.post(`/tables/${tableId}/orders`, {
// // //         items: order.map((o) => ({ item: o.item._id, qty: o.qty })),
// // //       });

// // //       // 🔥 EMIT TO SERVER FOR REALTIME UPDATE
// // //       socket.emit("orderUpdated", { tableId });


// // //       alert("✅ Order placed successfully!");
// // //       setOrder([]);

// // //     } catch (err) {
// // //       console.error("Order submit error:", err);
// // //       alert("❌ Failed to place order");
// // //     }
// // //   }

// // //   if (loading) return <div className="p-6 text-center">Loading...</div>;

// // //   const filteredMenu = menu.filter((m) =>
// // //     m.name.toLowerCase().includes(search.toLowerCase())
// // //   );

// // //   return (
// // //     <div className="p-6 bg-gray-50 min-h-screen">
// // //       <h2 className="text-2xl font-bold text-center mb-4">
// // //         🍽️ {table?.name}
// // //       </h2>

// // //       <div className="mb-4 flex justify-center">
// // //         <input
// // //           type="text"
// // //           placeholder="Search menu items..."
// // //           value={search}
// // //           onChange={(e) => setSearch(e.target.value)}
// // //           className="border p-2 w-full max-w-md rounded"
// // //         />
// // //       </div>

// // //       <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
// // //         {filteredMenu.length > 0 ? filteredMenu.map((m) => {
// // //           const itemInOrder = order.find(o => o.item._id === m._id);
// // //           const qty = itemInOrder ? itemInOrder.qty : 0;
// // //           return (
// // //             <div
// // //               key={m._id}
// // //               className="bg-white shadow rounded-lg p-3 flex flex-col items-center justify-between"
// // //             >

// // //               <div className="bg-white shadow rounded-lg p-4 mb-6">
// // //   <h3 className="font-semibold mb-2">🤖 AI Waiter</h3>

// // //   <div className="h-32 overflow-y-auto border p-2 mb-2 text-sm">
// // //     {chat.map((c, i) => (
// // //       <div key={i} className="mb-1">
// // //         <strong>{c.from === "ai" ? "Waiter" : "You"}:</strong> {c.text}
// // //       </div>
// // //     ))}
// // //   </div>

// // //   <div className="flex gap-2">
// // //     <input
// // //       value={aiInput}
// // //       onChange={(e) => setAiInput(e.target.value)}
// // //       placeholder="Type or speak your order..."
// // //       className="border p-2 flex-1 rounded"
// // //     />
// // //     <button
// // //       onClick={() => sendToAI(false)}
// // //       className="bg-blue-600 text-white px-4 rounded"
// // //     >
// // //       Send
// // //     </button>
// // //     <button
// // //       onClick={startVoice}
// // //       className="bg-gray-600 text-white px-3 rounded"
// // //     >
// // //       🎤
// // //     </button>
// // //   </div>

// // //   {pendingItems && (
// // //     <button
// // //       onClick={() => sendToAI(true)}
// // //       className="mt-3 bg-green-600 text-white w-full py-2 rounded"
// // //     >
// // //       ✅ Confirm AI Order
// // //     </button>
// // //   )}
// // // </div>

// // //               <div className="font-semibold">{m.name}</div>
// // //               <div className="text-gray-600">₹{m.price}</div>
// // //               <div className="flex items-center mt-2 gap-2">
// // //                 <button
// // //                   onClick={() => changeQty(m._id, qty - 1)}
// // //                   className="bg-gray-200 hover:bg-gray-300 w-8 h-8 rounded flex items-center justify-center font-bold"
// // //                 >
// // //                   −
// // //                 </button>
// // //                 <input
// // //                   type="number"
// // //                   min="0"
// // //                   value={qty}
// // //                   onChange={(e) => changeQty(m._id, Number(e.target.value))}
// // //                   className="w-12 text-center border rounded py-1"
// // //                 />
// // //                 <button
// // //                   onClick={() => addItem(m, 1)}
// // //                   className="bg-green-600 hover:bg-green-700 text-white w-8 h-8 rounded flex items-center justify-center font-bold"
// // //                 >
// // //                   +
// // //                 </button>
// // //               </div>
// // //               <div className="text-sm mt-1">
// // //                 Total: ₹{qty * m.price}
// // //               </div>
// // //             </div>
// // //           );
// // //         }) : (
// // //           <div className="col-span-full text-center text-gray-500">No items found</div>
// // //         )}
// // //       </div>

// // //       {order.length > 0 && (
// // //         <div className="bg-white shadow rounded-lg p-4 sticky bottom-4">
// // //           <h3 className="text-lg font-semibold mb-3">🧾 Your Order</h3>

// // //           {order.map((o) => (
// // //             <div key={o.item._id} className="flex justify-between items-center mb-2">
// // //               <span>{o.item.name}</span>
// // //               <span>₹{o.item.price * o.qty}</span>
// // //               <input
// // //                 type="number"
// // //                 min="1"
// // //                 value={o.qty}
// // //                 onChange={(e) => changeQty(o.item._id, Number(e.target.value))}
// // //                 className="border rounded px-2 w-16 text-center"
// // //               />
// // //             </div>
// // //           ))}

// // //           <div className="font-bold mt-2 flex justify-between">
// // //             <span>Total:</span>
// // //             <span>₹{order.reduce((sum, o) => sum + o.item.price * o.qty, 0)}</span>
// // //           </div>

// // //           <button
// // //             className="bg-blue-600 text-white w-full py-2 rounded mt-3 hover:bg-blue-700"
// // //             onClick={submitOrder}
// // //           >
// // //             ✅ Place Order
// // //           </button>
// // //         </div>
// // //       )}
// // //     </div>
// // //   );
// // // }


// // import React, { useEffect, useState } from "react";
// // import { useParams } from "react-router-dom";
// // import api from "../api";
// // import socket from "../socket";

// // export default function OrderFromCustomer() {
// //   const { tableId } = useParams();

// //   const [table, setTable] = useState(null);
// //   const [menu, setMenu] = useState([]);
// //   const [order, setOrder] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [search, setSearch] = useState("");

// //   // 🤖 AI Waiter state
// //   const [chat, setChat] = useState([]);
// //   const [aiInput, setAiInput] = useState("");
// //   const [pendingItems, setPendingItems] = useState(null);

// //   // ------------------------
// //   // Manual order helpers
// //   // ------------------------
// //   function addItem(item, qty = 1) {
// //     const existing = order.find((o) => o.item._id === item._id);
// //     if (existing) {
// //       setOrder(
// //         order.map((o) =>
// //           o.item._id === item._id ? { ...o, qty: o.qty + qty } : o
// //         )
// //       );
// //     } else {
// //       setOrder([...order, { item, qty }]);
// //     }
// //   }

// //   function changeQty(itemId, qty) {
// //     if (qty <= 0) {
// //       setOrder(order.filter((o) => o.item._id !== itemId));
// //     } else {
// //       setOrder(
// //         order.map((o) =>
// //           o.item._id === itemId ? { ...o, qty } : o
// //         )
// //       );
// //     }
// //   }

// //   // ------------------------
// //   // 🤖 AI Waiter logic
// //   // ------------------------
// //   async function sendToAI(confirm = false) {
// //   if (!aiInput && !confirm) return;

// //   // 👈 ADD THIS
// //   if (!confirm) {
// //     setChat(prev => [...prev, { from: "user", text: aiInput }]);
// //   }

// //   const res = await api.post("/waiter", {
// //     tableId,
// //     message: confirm ? "yes" : aiInput,
// //     confirm
// //   });

// //   if (res.data.reply) {
// //     setChat(prev => [...prev, { from: "ai", text: res.data.reply }]);
// //   }

// //   setAiInput("");
// // }

// //   function startVoice() {
// //     const SpeechRecognition =
// //       window.SpeechRecognition || window.webkitSpeechRecognition;

// //     if (!SpeechRecognition) {
// //       alert("Voice not supported on this browser");
// //       return;
// //     }

// //     const recognition = new SpeechRecognition();
// //     recognition.lang = "en-IN";

// //     recognition.onresult = (e) => {
// //       const text = e.results[0][0].transcript;
// //       setAiInput(text);
// //       sendToAI(false);
// //     };

// //     recognition.start();
// //   }

// //   // ------------------------
// //   // Load menu + table
// //   // ------------------------
// //   useEffect(() => {
// //     async function loadData() {
// //       try {
// //         const [tRes, mRes] = await Promise.all([
// //           api.get(`/tables/${tableId}`),
// //           api.get(`/menu`),
// //         ]);
// //         setTable(tRes.data);
// //         setMenu(mRes.data);
// //       } catch (err) {
// //         console.error("Load error:", err);
// //         alert("Failed to load menu or table info.");
// //       } finally {
// //         setLoading(false);
// //       }
// //     }
// //     loadData();
// //   }, [tableId]);

// //   // ------------------------
// //   // Manual order submit
// //   // ------------------------
// //   async function submitOrder() {
// //     if (order.length === 0) return alert("Please add at least one item.");

// //     try {
// //       await api.post(`/tables/${tableId}/orders`, {
// //         items: order.map((o) => ({ item: o.item._id, qty: o.qty })),
// //       });

// //       socket.emit("orderUpdated", { tableId });
// //       alert("✅ Order placed successfully!");
// //       setOrder([]);
// //     } catch (err) {
// //       console.error("Order submit error:", err);
// //       alert("❌ Failed to place order");
// //     }
// //   }

// //   if (loading) return <div className="p-6 text-center">Loading...</div>;

// //   const filteredMenu = menu.filter((m) =>
// //     m.name.toLowerCase().includes(search.toLowerCase())
// //   );

// //   return (
// //     <div className="p-6 bg-gray-50 min-h-screen">
// //       <h2 className="text-2xl font-bold text-center mb-4">
// //         🍽️ {table?.name}
// //       </h2>

// //       {/* 🤖 AI WAITER (ONLY ONCE) */}
// //       <div className="bg-white shadow rounded-lg p-4 mb-6">
// //         <h3 className="font-semibold mb-2">🤖 AI Waiter</h3>

// //         <div className="h-32 overflow-y-auto border p-2 mb-2 text-sm">
// //           {chat.map((c, i) => (
// //             <div key={i}>
// //               <strong>{c.from === "ai" ? "Waiter" : "You"}:</strong> {c.text}
// //             </div>
// //           ))}
// //         </div>

// //         <div className="flex gap-2">
// //           <input
// //             value={aiInput}
// //             onChange={(e) => setAiInput(e.target.value)}
// //             placeholder="Type or speak your order..."
// //             className="border p-2 flex-1 rounded"
// //           />
// //           <button
// //             onClick={() => sendToAI(false)}
// //             className="bg-blue-600 text-white px-4 rounded"
// //           >
// //             Send
// //           </button>
// //           <button
// //             onClick={startVoice}
// //             className="bg-gray-600 text-white px-3 rounded"
// //           >
// //             🎤
// //           </button>
// //         </div>

// //         {pendingItems && (
// //           <button
// //             onClick={() => sendToAI(true)}
// //             className="mt-3 bg-green-600 text-white w-full py-2 rounded"
// //           >
// //             ✅ Confirm AI Order
// //           </button>
// //         )}
// //       </div>

// //       {/* Search */}
// //       <div className="mb-4 flex justify-center">
// //         <input
// //           type="text"
// //           placeholder="Search menu items..."
// //           value={search}
// //           onChange={(e) => setSearch(e.target.value)}
// //           className="border p-2 w-full max-w-md rounded"
// //         />
// //       </div>

// //       {/* Menu */}
// //       <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
// //         {filteredMenu.map((m) => {
// //           const itemInOrder = order.find((o) => o.item._id === m._id);
// //           const qty = itemInOrder ? itemInOrder.qty : 0;

// //           return (
// //             <div
// //               key={m._id}
// //               className="bg-white shadow rounded-lg p-3 flex flex-col items-center"
// //             >
// //               <div className="font-semibold">{m.name}</div>
// //               <div className="text-gray-600">₹{m.price}</div>

// //               <div className="flex items-center mt-2 gap-2">
// //                 <button
// //                   onClick={() => changeQty(m._id, qty - 1)}
// //                   className="bg-gray-200 w-8 h-8 rounded"
// //                 >
// //                   −
// //                 </button>
// //                 <input
// //                   type="number"
// //                   value={qty}
// //                   min="0"
// //                   onChange={(e) =>
// //                     changeQty(m._id, Number(e.target.value))
// //                   }
// //                   className="w-12 text-center border rounded"
// //                 />
// //                 <button
// //                   onClick={() => addItem(m, 1)}
// //                   className="bg-green-600 text-white w-8 h-8 rounded"
// //                 >
// //                   +
// //                 </button>
// //               </div>

// //               <div className="text-sm mt-1">
// //                 Total: ₹{qty * m.price}
// //               </div>
// //             </div>
// //           );
// //         })}
// //       </div>

// //       {/* Manual order summary */}
// //       {order.length > 0 && (
// //         <div className="bg-white shadow rounded-lg p-4 sticky bottom-4">
// //           <h3 className="text-lg font-semibold mb-3">🧾 Your Order</h3>

// //           {order.map((o) => (
// //             <div key={o.item._id} className="flex justify-between mb-2">
// //               <span>{o.item.name}</span>
// //               <span>₹{o.item.price * o.qty}</span>
// //             </div>
// //           ))}

// //           <div className="font-bold flex justify-between">
// //             <span>Total:</span>
// //             <span>
// //               ₹{order.reduce((s, o) => s + o.item.price * o.qty, 0)}
// //             </span>
// //           </div>

// //           <button
// //             className="bg-blue-600 text-white w-full py-2 rounded mt-3"
// //             onClick={submitOrder}
// //           >
// //             ✅ Place Order
// //           </button>
// //         </div>
// //       )}
// //     </div>
// //   );
// // }


// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import api from "../api";
// import socket from "../socket";

// export default function OrderFromCustomer() {
//   const { tableId } = useParams();

//   const [table, setTable] = useState(null);
//   const [menu, setMenu] = useState([]);
//   const [order, setOrder] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");

//   // 🤖 AI Waiter
//   const [chat, setChat] = useState([]);
//   const [aiInput, setAiInput] = useState("");

//   /* -------------------------
//      MANUAL ORDER HELPERS
//   -------------------------- */
//   function addItem(item, qty = 1) {
//     setOrder(prev => {
//       const existing = prev.find(o => o.item._id === item._id);
//       if (existing) {
//         return prev.map(o =>
//           o.item._id === item._id ? { ...o, qty: o.qty + qty } : o
//         );
//       }
//       return [...prev, { item, qty }];
//     });
//   }

//   function changeQty(itemId, qty) {
//     setOrder(prev => {
//       if (qty <= 0) {
//         return prev.filter(o => o.item._id !== itemId);
//       }
//       return prev.map(o =>
//         o.item._id === itemId ? { ...o, qty } : o
//       );
//     });
//   }

//   /* -------------------------
//      🤖 AI WAITER LOGIC
//   -------------------------- */
//   async function sendToAI() {
//     if (!aiInput.trim()) return;

//     // show user message
//     setChat(prev => [...prev, { from: "user", text: aiInput }]);

//     const res = await api.post("/waiter", {
//       tableId,
//       message: aiInput,
//     });

//     if (res.data.reply) {
//       setChat(prev => [...prev, { from: "ai", text: res.data.reply }]);
//     }

//     // 🔥 MERGE AI ITEMS INTO MANUAL ORDER
//     if (Array.isArray(res.data.items)) {
//       setOrder(prev => {
//         const updated = [...prev];

//         for (const aiItem of res.data.items) {
//           const existing = updated.find(
//             o => o.item._id === aiItem.item
//           );

//           if (existing) {
//             existing.qty = aiItem.qty;
//           } else {
//             const menuItem = menu.find(m => m._id === aiItem.item);
//             if (menuItem) {
//               updated.push({
//                 item: menuItem,
//                 qty: aiItem.qty,
//               });
//             }
//           }
//         }
//         return [...updated];
//       });
//     }

//     setAiInput("");
//   }

//   function startVoice() {
//     const SpeechRecognition =
//       window.SpeechRecognition || window.webkitSpeechRecognition;

//     if (!SpeechRecognition) {
//       alert("Voice not supported");
//       return;
//     }

//     const recognition = new SpeechRecognition();
//     recognition.lang = "en-IN";

//     recognition.onresult = e => {
//       const text = e.results[0][0].transcript;
//       setAiInput(text);
//     };

//     recognition.start();
//   }

//   /* -------------------------
//      LOAD TABLE + MENU
//   -------------------------- */
//   useEffect(() => {
//     async function load() {
//       try {
//         const [tRes, mRes] = await Promise.all([
//           api.get(`/tables/${tableId}`),
//           api.get(`/menu`),
//         ]);
//         setTable(tRes.data);
//         setMenu(mRes.data);
//       } catch {
//         alert("Failed to load menu or table");
//       } finally {
//         setLoading(false);
//       }
//     }
//     load();
//   }, [tableId]);

//   /* -------------------------
//      PLACE ORDER
//   -------------------------- */
//   async function submitOrder() {
//     if (order.length === 0) {
//       alert("Please add at least one item.");
//       return;
//     }

//     try {
//       await api.post(`/tables/${tableId}/orders`, {
//         items: order.map(o => ({
//           item: o.item._id,
//           qty: o.qty,
//         })),
//       });

//       socket.emit("orderUpdated", { tableId });
//       alert("✅ Order placed successfully!");
//       setOrder([]);
//       setChat([]);
//     } catch {
//       alert("❌ Failed to place order");
//     }
//   }

//   if (loading) return <div className="p-6 text-center">Loading...</div>;

//   const filteredMenu = menu.filter(m =>
//     m.name.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <div className="p-6 bg-gray-50 min-h-screen">
//       <h2 className="text-2xl font-bold text-center mb-4">
//         🍽️ {table?.name}
//       </h2>

//       {/* 🤖 AI WAITER */}
//       <div className="bg-white shadow rounded-lg p-4 mb-6">
//         <h3 className="font-semibold mb-2">🤖 AI Waiter</h3>

//         <div className="h-32 overflow-y-auto border p-2 mb-2 text-sm">
//           {chat.map((c, i) => (
//             <div key={i}>
//               <strong>{c.from === "ai" ? "Waiter" : "You"}:</strong>{" "}
//               {c.text}
//             </div>
//           ))}
//         </div>

//         <div className="flex gap-2">
//           <input
//             value={aiInput}
//             onChange={e => setAiInput(e.target.value)}
//             placeholder="Type or speak your order..."
//             className="border p-2 flex-1 rounded"
//           />
//           <button
//             onClick={sendToAI}
//             className="bg-blue-600 text-white px-4 rounded"
//           >
//             Send
//           </button>
//           <button
//             onClick={startVoice}
//             className="bg-gray-600 text-white px-3 rounded"
//           >
//             🎤
//           </button>
//         </div>
//       </div>

//       {/* SEARCH */}
//       <div className="mb-4 flex justify-center">
//         <input
//           value={search}
//           onChange={e => setSearch(e.target.value)}
//           placeholder="Search menu..."
//           className="border p-2 w-full max-w-md rounded"
//         />
//       </div>

//       {/* MENU */}
//       <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
//         {filteredMenu.map(m => {
//           const itemInOrder = order.find(o => o.item._id === m._id);
//           const qty = itemInOrder ? itemInOrder.qty : 0;

//           return (
//             <div key={m._id} className="bg-white shadow rounded-lg p-3">
//               <div className="font-semibold">{m.name}</div>
//               <div className="text-gray-600">₹{m.price}</div>

//               <div className="flex items-center mt-2 gap-2">
//                 <button
//                   onClick={() => changeQty(m._id, qty - 1)}
//                   className="bg-gray-200 w-8 h-8 rounded"
//                 >
//                   −
//                 </button>
//                 <input
//                   type="number"
//                   value={qty}
//                   min="0"
//                   onChange={e =>
//                     changeQty(m._id, Number(e.target.value))
//                   }
//                   className="w-12 text-center border rounded"
//                 />
//                 <button
//                   onClick={() => addItem(m, 1)}
//                   className="bg-green-600 text-white w-8 h-8 rounded"
//                 >
//                   +
//                 </button>
//               </div>

//               <div className="text-sm mt-1">
//                 Total: ₹{qty * m.price}
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       {/* ORDER SUMMARY */}
//       {order.length > 0 && (
//         <div className="bg-white shadow rounded-lg p-4 sticky bottom-4">
//           <h3 className="text-lg font-semibold mb-3">🧾 Your Order</h3>

//           {order.map(o => (
//             <div key={o.item._id} className="flex justify-between mb-2">
//               <span>{o.item.name}</span>
//               <span>₹{o.item.price * o.qty}</span>
//             </div>
//           ))}

//           <div className="font-bold flex justify-between">
//             <span>Total:</span>
//             <span>
//               ₹{order.reduce(
//                 (sum, o) => sum + o.item.price * o.qty,
//                 0
//               )}
//             </span>
//           </div>

//           <button
//             className="bg-blue-600 text-white w-full py-2 rounded mt-3"
//             onClick={submitOrder}
//           >
//             ✅ Place Order
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../api";
import socket from "../socket";

export default function OrderFromCustomer() {
  const { tableId } = useParams();

  const [table, setTable] = useState(null);
  const [menu, setMenu] = useState([]);
  const [order, setOrder] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  // 🤖 AI waiter
  const [chat, setChat] = useState([]);
  const [aiInput, setAiInput] = useState("");

  /* -------------------------
     ORDER HELPERS
  -------------------------- */
  function addItem(item, qty = 1) {
    setOrder(prev => {
      const existing = prev.find(o => o.item._id === item._id);
      if (existing) {
        return prev.map(o =>
          o.item._id === item._id
            ? { ...o, qty: o.qty + qty }
            : o
        );
      }
      return [...prev, { item, qty }];
    });
  }

  function changeQty(itemId, qty) {
    setOrder(prev => {
      if (qty <= 0) {
        return prev.filter(o => o.item._id !== itemId);
      }
      return prev.map(o =>
        o.item._id === itemId ? { ...o, qty } : o
      );
    });
  }

  /* -------------------------
     🤖 AI WAITER
  -------------------------- */
  // async function sendToAI() {
  //   if (!aiInput.trim()) return;

  //   setChat(prev => [...prev, { from: "user", text: aiInput }]);

  //   const res = await api.post("/waiter", {
  //     tableId,
  //     message: aiInput,
  //   });

  //   if (res.data.reply) {
  //     setChat(prev => [...prev, { from: "ai", text: res.data.reply }]);
  //   }

  //   // merge AI items into order
  //   if (Array.isArray(res.data.items)) {
  //     setOrder(prev => {
  //       const updated = [...prev];

  //       for (const aiItem of res.data.items) {
  //         const existing = updated.find(
  //           o => o.item._id === aiItem.item
  //         );

  //         if (existing) {
  //           existing.qty = aiItem.qty;
  //         } else {
  //           const menuItem = menu.find(m => m._id === aiItem.item);
  //           if (menuItem) {
  //             updated.push({ item: menuItem, qty: aiItem.qty });
  //           }
  //         }
  //       }
  //       return [...updated];
  //     });
  //   }

  //   setAiInput("");
  // }

  async function sendToAI() {
  if (!aiInput.trim()) return;

  setChat(prev => [...prev, { from: "user", text: aiInput }]);

  const res = await api.post("/waiter", {
    tableId,
    message: aiInput,
  });

  if (res.data.reply) {
    setChat(prev => [...prev, { from: "ai", text: res.data.reply }]);
  }

  // ✅ ORDER PLACED VIA AI → CLEAR ONLY ORDER LIST
  if (res.data.success === true) {
    setOrder([]);        // 🧾 list disappears
    setAiInput("");     // input clears
    return;              // 🔴 DO NOT clear chat
  }

  // merge AI items into order
  if (Array.isArray(res.data.items)) {
    setOrder(prev => {
      const updated = [...prev];

      for (const aiItem of res.data.items) {
        const existing = updated.find(
          o => o.item._id === aiItem.item
        );

        if (existing) {
          existing.qty = aiItem.qty;
        } else {
          const menuItem = menu.find(m => m._id === aiItem.item);
          if (menuItem) {
            updated.push({ item: menuItem, qty: aiItem.qty });
          }
        }
      }
      return [...updated];
    });
  }

  setAiInput("");
}


  function startVoice() {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      alert("Voice not supported");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = "en-IN";

    recognition.onresult = e => {
      setAiInput(e.results[0][0].transcript);
    };

    recognition.start();
  }

  /* -------------------------
     LOAD DATA
  -------------------------- */
  useEffect(() => {
    async function load() {
      try {
        const [tRes, mRes] = await Promise.all([
          api.get(`/tables/${tableId}`),
          api.get(`/menu`),
        ]);
        setTable(tRes.data);
        setMenu(mRes.data);
      } catch {
        alert("Failed to load menu or table");
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [tableId]);

  /* -------------------------
     PLACE ORDER
  -------------------------- */
  async function submitOrder() {
    if (order.length === 0) {
      alert("Please add at least one item.");
      return;
    }

    try {
      await api.post(`/tables/${tableId}/orders`, {
        items: order.map(o => ({
          item: o.item._id,
          qty: o.qty,
        })),
      });

      socket.emit("orderUpdated", { tableId });
      alert("✅ Order placed successfully!");
      setOrder([]);
      setChat([]);
    } catch {
      alert("❌ Failed to place order");
    }
  }

  if (loading) return <div className="p-6 text-center">Loading...</div>;

  const filteredMenu = menu.filter(m =>
    m.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h2 className="text-2xl font-bold text-center mb-4">
        🍽️ {table?.name}
      </h2>

      {/* 🤖 AI WAITER */}
      <div className="bg-white shadow rounded-lg p-4 mb-6">
        <h3 className="font-semibold mb-2">🤖 AI Waiter</h3>

        <div className="h-32 overflow-y-auto border p-2 mb-2 text-sm">
          {chat.map((c, i) => (
            <div key={i}>
              <strong>{c.from === "ai" ? "Waiter" : "You"}:</strong>{" "}
              {c.text}
            </div>
          ))}
        </div>

        <div className="flex gap-2">
          <input
            value={aiInput}
            onChange={e => setAiInput(e.target.value)}
            placeholder="Type or speak your order..."
            className="border p-2 flex-1 rounded"
          />
          <button
            onClick={sendToAI}
            className="bg-blue-600 text-white px-4 rounded"
          >
            Send
          </button>
          <button
            onClick={startVoice}
            className="bg-gray-600 text-white px-3 rounded"
          >
            🎤
          </button>
        </div>
      </div>

      {/* SEARCH */}
      <div className="mb-4 flex justify-center">
        <input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Search menu..."
          className="border p-2 w-full max-w-md rounded"
        />
      </div>

      {/* MENU */}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        {filteredMenu.map(m => {
          const itemInOrder = order.find(o => o.item._id === m._id);
          const qty = itemInOrder ? itemInOrder.qty : 0;

          return (
            <div key={m._id} className="bg-white shadow rounded-lg p-3">
              <div className="font-semibold">{m.name}</div>
              <div className="text-gray-600">₹{m.price}</div>

              <div className="flex items-center mt-2 gap-2">
                <button
                  onClick={() => changeQty(m._id, qty - 1)}
                  className="bg-gray-200 w-8 h-8 rounded"
                >
                  −
                </button>

                <span className="w-6 text-center font-semibold">
                  {qty}
                </span>

                <button
                  onClick={() => addItem(m, 1)}
                  className="bg-green-600 text-white w-8 h-8 rounded"
                >
                  +
                </button>
              </div>

              <div className="text-sm mt-1">
                Total: ₹{qty * m.price}
              </div>
            </div>
          );
        })}
      </div>

      {/* 🧾 YOUR ORDER */}
      {order.length > 0 && (
        <div className="bg-white shadow rounded-lg p-4 sticky bottom-4">
          <h3 className="text-lg font-semibold mb-3">🧾 Your Order</h3>

          {order.map(o => (
            <div
              key={o.item._id}
              className="flex items-center justify-between mb-3"
            >
              <div>
                <div className="font-medium">{o.item.name}</div>
                <div className="text-sm text-gray-500">
                  ₹{o.item.price} each
                </div>
              </div>

              <div className="flex items-center gap-2">
                <button
                  onClick={() =>
                    changeQty(o.item._id, o.qty - 1)
                  }
                  className="bg-gray-200 w-8 h-8 rounded"
                >
                  −
                </button>

                <span className="w-6 text-center font-semibold">
                  {o.qty}
                </span>

                <button
                  onClick={() =>
                    changeQty(o.item._id, o.qty + 1)
                  }
                  className="bg-green-600 text-white w-8 h-8 rounded"
                >
                  +
                </button>
              </div>

              <div className="font-semibold">
                ₹{o.item.price * o.qty}
              </div>
            </div>
          ))}

          <div className="font-bold flex justify-between border-t pt-2 mt-2">
            <span>Total:</span>
            <span>
              ₹
              {order.reduce(
                (sum, o) => sum + o.item.price * o.qty,
                0
              )}
            </span>
          </div>

          <button
            className="bg-blue-600 text-white w-full py-2 rounded mt-3"
            onClick={submitOrder}
          >
            ✅ Place Order
          </button>
        </div>
      )}
    </div>
  );
}
